import { MealType } from '@akin-home/amplify';

export const default_meal_times = {
  [MealType.Breakfast]: '07:00',
  [MealType.Lunch]: '12:30',
  [MealType.Dinner]: '06:30',
  [MealType.Snack]: '08:00',
};
